import { useEffect, useState } from "react";
import useGetData from "../../../hook/getData";
import { GetAddress } from "../../../services/panel/address/getAddress";
import { IconMap2, IconX } from "@tabler/icons-react";
import { useMutation } from "@tanstack/react-query";
import Select from 'react-select';
import { toast } from "react-toastify";
import { onError } from "../../../features/error/error";
import { toastOptions } from "../../../features/toast/toast";
import { SendAddress } from "../../../services/panel/address/sendAddress";
import { useForm } from "react-hook-form";
import { GetProvinces } from "../../../services/panel/address/getProvinces";
import { GetCities } from "../../../services/panel/address/getCities";
import { GetProfile } from "../../../services/panel/profile/getProfile";

const AddressUser = () => {
    const { data: address, refetch: adrefe } = useGetData(['address'], GetAddress);
    const { data: provinces } = useGetData(['provinces'], GetProvinces);
    let [cities, setCities] = useState([]);
    const { register, handleSubmit, reset }: any = useForm<any>();
    const { data: profile } = useGetData(['profile'], GetProfile);
    useEffect(() => {
        reset({
            name: profile?.name || '',
            lastName: profile?.lastName || '',
            email: profile?.email || '',
            national_code: profile?.national_code,
            gender: profile?.gender,
            cellphone: profile?.cellphone,
            nationalCode: profile?.national_code,
        });
    }, [profile?.cellphone, profile?.email, profile?.gender, profile?.lastName, profile?.name, profile?.national_code, reset]);
    const addreeMutation = useMutation({
        mutationFn: SendAddress,
        onSuccess: () => {
            adrefe();
            document.getElementById('close-addrees')?.click();
        },
        onError: (error: any) => {
            const errors: any = error.response.data?.message;
            if (errors) {
                for (const [, messages] of Object.entries(errors)) {
                    (messages as string[]).forEach((message) => {
                        toast.error(message, toastOptions);
                    });
                }
            }
        },
    });
    const [isSelfReceiver, setIsSelfReceiver] = useState(false);
    const cityMutation = useMutation({
        mutationFn: GetCities,
        onSuccess: (data) => {
            let cityOptions = data?.map((p: { id: any; name: any; }) => ({
                value: p.id,
                label: p.name
            }));
            setCities(cityOptions)
        },
        onError: (error: any) => {
            const errors: any = error.response.data?.message;
            if (errors) {
                for (const [, messages] of Object.entries(errors)) {
                    (messages as string[]).forEach((message) => {
                        toast.error(message, toastOptions);
                    });
                }
            }
        },
    });
    const [value, setValue] = useState(null);
    const onChange = (selectedOption: any) => {
        setValue(selectedOption?.value);
        cityMutation.mutate(selectedOption?.value)
    };
    const [Cityvalue, setCityValue] = useState(null);

    const onChangeCity = (selectedOption: any) => {
        setCityValue(selectedOption?.value);
    };

    const provinceOptions = provinces?.map((p: { id: any; name: any; }) => ({
        value: p.id,
        label: p.name
    }));

    const onSubmit = (data: any) => {
        data.province_id = value;
        data.city_id = Cityvalue;
        data.im_receiver = isSelfReceiver ? 1 : 0;
        addreeMutation.mutate(data)
    }
    return (
        <>
            <div className="card card-body shadow border-1 rounded rounded-4">
                <div className="rounded box-site rounded-4 d-flex justify-content-between align-items-center py-3 mb-0">
                    <span>آدرس</span>
                </div>
                <div className="row mt-3">
                    <div className="col-md-12">
                        <ul className="list-group px-0">
                            {address?.addresses?.map((address: any) => (
                                <li key={address.id} className="list-group-item px-0">
                                    <div
                                        className={`d-md-flex align-items-center justify-content-between border border-1 py-3 px-md-3 px-3 rounded rounded-3 p-2`}>
                                        <input type="radio"
                                            name="address"
                                            value={address.id}
                                            className="form-check-input d-md-none d-inline-block border-2 border-black" />
                                        <div className="d-flex align-items-center">
                                            <IconMap2 className="d-md-inline d-none" />
                                            <div className="ms-3">
                                                <p className="mb-2">
                                                    {address.title}
                                                </p>
                                                <ul className="breadcrumb">
                                                    <li className="breadcrumb-item text-muted font-medium">
                                                        جزئیات آدرس :
                                                        {address.address}
                                                    </li>
                                                    <li className="breadcrumb-item text-muted font-medium">
                                                        شماره تماس : {address.cellphone}
                                                    </li>
                                                    <li className="breadcrumb-item d-md-inline d-none text-muted font-medium">
                                                        کد پستی : {address.postal_code}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div>
                    <button data-bs-toggle="modal" data-bs-target="#address-modal" className="btn btn-outline-primary mt-2">
                        افزودن آدرس
                    </button>
                </div>
            </div>
            <div className="modal fade" id="address-modal">
                <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg">
                    <div className="modal-content p-3">
                        <div className="modal-header justify-content-between">
                            <h5 className="mb-0 fw-bold text-site">افزودن آدرس</h5>
                            <IconX data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <h6 className="mt-2 mb-1">مشخصات خود را وارد نمایید</h6>
                            <form onSubmit={handleSubmit(onSubmit, onError)}>
                                <div className="row mb-3 gy-3 mt-1">
                                    <div className="col-md-6">
                                        <fieldset className="form-floating">
                                            <input
                                                type="text"
                                                placeholder="نام"
                                                className="form-control"
                                                {...register("name", { required: false })}
                                            />
                                            <label className="form-label">نام</label>
                                        </fieldset>
                                    </div>
                                    <div className="col-md-6">
                                        <fieldset className="form-floating">
                                            <input
                                                type="text"
                                                placeholder="نام خانوادگی"
                                                className="form-control"
                                                {...register("lastName", { required: false })}
                                            />
                                            <label className="form-label">نام خانوادگی</label>
                                        </fieldset>
                                    </div>
                                    <div className="col-md-6">
                                        <fieldset className="form-floating">
                                            <input
                                                type="tel"
                                                placeholder="شماره موبایل"
                                                className="form-control"
                                                {...register("cellphone", { required: false })}
                                            />
                                            <label className="form-label">شماره موبایل</label>
                                        </fieldset>
                                    </div>
                                    <div className="col-md-6">
                                        <fieldset className="form-floating">
                                            <input
                                                type="text"
                                                placeholder="کدملی"
                                                className="form-control"
                                                {...register("nationalCode", { required: false })}
                                            />
                                            <label className="form-label">کدملی</label>
                                        </fieldset>
                                    </div>
                                </div>
                                <hr />
                                <div className="row align-items-center">
                                    <h6 className="mt-2 mb-3">جزئیات آدرس را وارد کنید</h6>
                                    <div className="col-md-12">
                                        <div className="row align-items-center gy-4">
                                            <div className="col-md-6">
                                                <Select
                                                    styles={{
                                                        control: (baseStyles) => ({
                                                            ...baseStyles,
                                                            height: 52,
                                                            minHeight: 52,
                                                        }),
                                                        menuPortal: (base) => ({
                                                            ...base,
                                                            zIndex: 99999,
                                                        }),
                                                    }}
                                                    options={provinceOptions}
                                                    onChange={onChange}
                                                    value={provinceOptions?.find((opt: { value: any; }) => opt.value === value)}
                                                    classNamePrefix="select border"
                                                    placeholder="انتخاب استان"
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <Select
                                                    styles={{
                                                        control: (baseStyles) => ({
                                                            ...baseStyles,
                                                            height: 52,
                                                            minHeight: 52,
                                                        }),
                                                        menuPortal: (base) => ({
                                                            ...base,
                                                            zIndex: 9999,
                                                        }),
                                                    }}
                                                    options={cities}
                                                    onChange={onChangeCity}
                                                    value={cities?.find((opt: { value: any; }) => opt.value === Cityvalue)}
                                                    classNamePrefix="select border"
                                                    placeholder="انتخاب شهر"
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <fieldset className="form-floating">
                                                    <input type="text" placeholder="عنوان" className="form-control"
                                                        {...register('title', { required: 'فیلد عنوان الزامی است' })}
                                                    />
                                                    <label className="form-label">عنوان</label>
                                                </fieldset>
                                            </div>
                                            <div className="col-md-6">
                                                <fieldset className="form-floating">
                                                    <input type="text" placeholder="آدرس" className="form-control"
                                                        {...register('address', { required: 'فیلد آدرس الزامی است' })}
                                                    />
                                                    <label className="form-label">آدرس</label>
                                                </fieldset>
                                            </div>
                                            <div className="col-md-12">
                                                <fieldset className="form-floating">
                                                    <input maxLength={10} type="tel" placeholder="کدپستی" className="form-control"
                                                        {...register('postal_code', { required: 'فیلد کد پستی الزامی است' })}
                                                    />
                                                    <label className="form-label">کدپستی (10 رقم)</label>
                                                </fieldset>
                                            </div>
                                        </div>
                                        <hr />
                                        <h6 className="mt-3 mb-2">مشخصات گیرنده را وارد نمایید</h6>
                                        <fieldset className="form-check mt-3">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={isSelfReceiver}
                                                onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    setIsSelfReceiver(checked);
                                                    if (checked && profile) {
                                                        reset((prev: any) => ({
                                                            ...prev,
                                                            receiver_first_name: profile?.name || '',
                                                            receiver_last_name: profile?.lastName || '',
                                                            receiver_cellphone: profile?.cellphone || '',
                                                            receiver_national_code: profile?.national_code || ''
                                                        }));
                                                    } else {
                                                        reset((prev: any) => ({
                                                            ...prev,
                                                            receiver_first_name: '',
                                                            receiver_last_name: '',
                                                            receiver_cellphone: '',
                                                            receiver_national_code: ''
                                                        }));
                                                    }
                                                }}
                                            />
                                            <label className="form-check-label">گیرنده خودم هستم</label>
                                        </fieldset>
                                        <div className="row mb-3 gy-3 mt-2">
                                            <div className="col-md-6">
                                                <fieldset className="form-floating">
                                                    <input
                                                        type="text"
                                                        placeholder="نام گیرنده"
                                                        className="form-control"
                                                        {...register("receiver_first_name", { required: 'نام گیرنده الزامی است' })}
                                                    />
                                                    <label className="form-label">نام گیرنده</label>
                                                </fieldset>
                                            </div>
                                            <div className="col-md-6">
                                                <fieldset className="form-floating">
                                                    <input
                                                        type="text"
                                                        placeholder="نام خانوادگی گیرنده"
                                                        className="form-control"
                                                        {...register("receiver_last_name", { required: 'نام خانوادگی گیرنده الزامی است' })}
                                                    />
                                                    <label className="form-label">نام خانوادگی گیرنده</label>
                                                </fieldset>
                                            </div>
                                            <div className="col-md-6">
                                                <fieldset className="form-floating">
                                                    <input
                                                        type="tel"
                                                        placeholder="شماره موبایل"
                                                        className="form-control"
                                                        {...register("receiver_cellphone", { required: 'شماره موبایل گیرنده الزامی است' })}
                                                    />
                                                    <label className="form-label">شماره موبایل</label>
                                                </fieldset>
                                            </div>
                                            <div className="col-md-6">
                                                <fieldset className="form-floating">
                                                    <input
                                                        type="text"
                                                        placeholder="کدملی گیرنده"
                                                        className="form-control"
                                                        {...register("receiver_national_code", { required: 'کدملی گیرنده الزامی است' })}
                                                    />
                                                    <label className="form-label">کدملی گیرنده</label>
                                                </fieldset>
                                            </div>
                                        </div>
                                        <button id="close-addrees" data-bs-dismiss="modal" type="button" className="d-none"></button>
                                        <button disabled={addreeMutation.isPending} className="btn py-3 w-100 btn-outline-primary mt-4">
                                            افزودن آدرس
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddressUser;